import { organisationConstants } from "../_constants/organisation.constants";
import { organisationService } from "../_services/organisation.service";

import { adminOrgActions } from "./organisations/orgAdminList.action";
import { creditOrgActions } from "./organisations/orgcredits.action";
import { creditListActions } from "./sellers/creditlist.actions";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "../_components/common/Form2/index.css";

export const organisationAction = {
  getIntrumentList,
  getOrganisation,
  addOrganisation,
  deleteOrganisation,
  editOrganisation,
  addOrganisationAdmin,
  makePrimaryAdmin,
  removeOrgAdmin,
  setIds,
  batchPermissionAction,
  sellOrgCreditAction,
  revokeOrgCreditAction,
  getDemographicDownload,
  deleteOrgAdmin
};

function getDemographicDownload(data, callback) {
  return (dispatch) => {
    dispatch(request());
    organisationService.demographicDownload(data).then(
      (demographic_download) => {
        dispatch(success(demographic_download));
        if (callback) {
          callback(demographic_download);
        }
      },
      (error) => {
        dispatch(failure(error));
      }
    );
  };

  function request() {
    return { type: organisationConstants.REQUEST_DEMOGRAPHIC_DOWNLOAD };
  }
  function success(demographic_download) {
    return {
      type: organisationConstants.RESPONSE_DEMOGRAPHIC_DOWNLOAD,
      demographic_download,
    };
  }
  function failure(error) {
    return { type: organisationConstants.ERROR_DEMOGRAPHIC_DOWNLOAD, error };
  }
}

function getIntrumentList() {
  return (dispatch) => {
    dispatch(request());
    organisationService.getIntrumentListFull().then(
      (instruments) => {

        dispatch(success(instruments));
      },
      (error) => {
        dispatch(failure(error));
      }
    );
  };

  function request() {
    return { type: organisationConstants.REQUEST_INSTRUMENT };
  }
  function success(instruments) {
    return { type: organisationConstants.RECIEVE_INSTRUMENT, instruments };
  }
  function failure(error) {
    return { type: organisationConstants.ERROR_INSTRUMENT, error };
  }
}

function getOrganisation(callback) {
  return (dispatch) => {
    dispatch(request());
    organisationService.getOrgData().then(
      (orgs) => {
        dispatch(success(orgs));
        callback ? callback(orgs) : null;
      },
      (error) => {
        dispatch(failure(error));
      }
    );
  };

  function request() {
    return { type: organisationConstants.REQUEST_ORGANISATION };
  }
  function success(orgs) {
    return { type: organisationConstants.RECIEVE_ORGANISATION, orgs };
  }
  function failure(error) {
    return { type: organisationConstants.ERROR_ORGANISATION, error };
  }
}

function addOrganisation(data, callback) {
  data["seller"] = data["seller_name"];
  delete data["seller_name"];
  data["country"] = data["country_name"];
  delete data["country_name"];

  return (dispatch) => {
    dispatch(request());
    organisationService.addOrgData(data).then(
      (orgAdd) => {
        dispatch(success(orgAdd));
        if (callback) {
          callback(orgAdd);
        }

        let toastId = toast["info"](`Organisation ${orgAdd.data.message}`, {
          position: toast.POSITION.BOTTOM_LEFT,
          autoClose: 1500,
        });

        toast.update(toastId, {
          render: `Organisation ${orgAdd.data.message}`,
          type: toast.TYPE.INFO,
          className: "styleToastSuccess",
        });
        dispatch(getOrganisation());
      },
      (error) => {
        dispatch(failure(error));
      }
    );

    function request() {
      return { type: organisationConstants.REQUEST_ADD_ORG };
    }
    function success(orgs) {
      return { type: organisationConstants.RESPONSE_ADD_ORG, orgs };
    }
    function failure(error) {
      return { type: organisationConstants.REQUEST_ERROR_ORG, error };
    }
  };
}

function deleteOrganisation(data) {
  return (dispatch) => {
    dispatch(request());
    organisationService.delOrgData(data).then(
      (deleted) => {
        dispatch(
          success({
            id: data.organisation_id,
            deleted,
          })
        );
      },
      (error) => {
        dispatch(success(error));
      }
    );
  };
  function request() {
    return { type: organisationConstants.REQUEST_DEL_ORG };
  }
  function success(delOrgs) {
    return { type: organisationConstants.RESPONSE_DEL_ORG, delOrgs };
  }

}

function editOrganisation(data) {
  return (dispatch) => {
    dispatch(request());
    organisationService.editOrgData(data).then(
      (edited) => {
        dispatch(success(edited));
        dispatch(getOrganisation());
      },
      (error) => {
        dispatch(failure(error));
      }
    );
  };
  function request() {
    return { type: organisationConstants.REQUEST_EDIT_ORG };
  }
  function success(edited) {
    return { type: organisationConstants.RESPONSE_EDIT_ORG, edited };
  }
  function failure(error) {
    return { type: organisationConstants.ERROR_EDIT_ORG, error };
  }
}

function addOrganisationAdmin(data) {
  return (dispatch) => {
    dispatch(request(data));
    organisationService.adminOrgData(data).then(
      (adminList) => {
        dispatch(success(adminList));
        dispatch(
          adminOrgActions.getAdminList(data.seller_id, data.oganisation_id)
        );
      },
      (error) => {
        dispatch(failure(error));
      }
    );
  };

  function request(requested) {
    return {
      type: organisationConstants.REQUEST_ADD_ADMIN_ORG,
      payload: requested,
    };
  }
  function success(editOrgs) {
    return { type: organisationConstants.RESPONSE_ADD_ADMIN_ORG, editOrgs };
  }
  function failure(error) {
    return { type: organisationConstants.ERROR_ADD_ADMIN_ORG, error };
  }
}

function makePrimaryAdmin(data) {
  return (dispatch) => {
    dispatch(request(data));
    organisationService.makeAdminOrgData(data).then(
      (adminListMake) => {
        dispatch(success(adminListMake));
        dispatch(adminOrgActions.getAdminList(data.seller_id, data.org_id));
      },
      (error) => {
        dispatch(failure(error));
      }
    );
  };

  function request(requested) {
    return {
      type: organisationConstants.REQUEST_PRIMARY_ADMIN_ORG,
      payload: requested,
    };
  }
  function success(adminListMake) {
    return {
      type: organisationConstants.RESPONSE_PRIMARY_ADMIN_ORG,
      adminListMake,
    };
  }
  function failure(error) {
    return { type: organisationConstants.ERROR_PRIMARY_ADMIN_ORG, error };
  }
}

function removeOrgAdmin(data) {
  return (dispatch) => {
    dispatch(request());
    organisationService.removeAdminOrgData(data).then(
      (removed) => {
        dispatch(success(removed));
        dispatch(adminOrgActions.getAdminList(data.seller_id, data.org_id));
      },
      (error) => {
        dispatch(failure(error));
      }
    );
  };

  function request() {
    return { type: organisationConstants.REQUEST_REMOVE_ADMIN_ORG };
  }
  function success(removed) {
    return { type: organisationConstants.RESPONSE_REMOVE_ADMIN_ORG, removed };
  }
  function failure(error) {
    return { type: organisationConstants.ERROR_REMOVE_ADMIN_ORG, error };
  }
}


function deleteOrgAdmin(data) {
  return (dispatch) => {
    dispatch(request(data));
    organisationService.deleteAdminOrgData(data).then(
      (removed) => {
        dispatch(success(removed));
        dispatch(adminOrgActions.getAdminList(data.seller_id, data.org_id));
      },
      (error) => {
        dispatch(failure(error));
      }
    );
  };

  function request(data) {
    return { type: organisationConstants.REQUEST_DELETE_ADMIN_ORG, payload: data };
  }
  function success(removed) {
    return { type: organisationConstants.RESPONSE_DELETE_ADMIN_ORG, removed };
  }
  function failure(error) {
    return { type: organisationConstants.ERROR_DELETE_ADMIN_ORG, error };
  }
}




function batchPermissionAction(data, callback) {
  return (dispatch) => {
    dispatch(request());
    organisationService.batchPermAdminOrgData(data).then(
      (batchPerm) => {
        dispatch(success(batchPerm));
        dispatch(adminOrgActions.getAdminList(data.sellerId, data.orgId));
        if (callback) {
          callback(batchPerm);
        }
      },
      (error) => {
        dispatch(failure(error));
      }
    );
  };

  function request() {
    return { type: organisationConstants.REQUEST_BATCH_ADMIN_ORG };
  }
  function success(batchPerm) {
    return { type: organisationConstants.RESPONSE_BATCH_ADMIN_ORG, batchPerm };
  }
  function failure(error) {
    return { type: organisationConstants.ERROR_BATCH_ADMIN_ORG, error };
  }
}

function sellOrgCreditAction(data) {

  return (dispatch) => {
    dispatch(request());
    organisationService.sellOrgCreditService(data).then(
      (sell_org_credits) => {
        dispatch(success(sell_org_credits));
        dispatch(creditListActions.getCreditList(data.seller_id));
        dispatch(
          creditOrgActions.getOrgCredit(data.seller_id, data.organisation)
        );
      },
      (error) => {
        dispatch(failure(error));
      }
    );
  };

  function request() {
    return { type: organisationConstants.REQUEST_SELL_ORG_CREDITS };
  }
  function success(sell_org_credits) {
    return {
      type: organisationConstants.RESPONSE_SELL_ORG_CREDITS,
      sell_org_credits,
    };
  }
  function failure(error) {
    return { type: organisationConstants.ERROR_SELL_ORG_CREDITS, error };
  }
}

function revokeOrgCreditAction(data) {

  return (dispatch) => {
    dispatch(request());
    organisationService.revokeOrgCreditService(data).then(
      (revoke_org_credits) => {
        dispatch(success(revoke_org_credits));
        dispatch(
          creditOrgActions.getOrgCredit(data.seller_id, data.organisation)
        );
      },
      (error) => {
        dispatch(failure(error));
      }
    );
  };

  function request() {
    return { type: organisationConstants.REQUEST_REVOKE_ORG_CREDITS };
  }
  function success(revoke_org_credits) {
    return {
      type: organisationConstants.RESPONSE_REVOKE_ORG_CREDITS,
      revoke_org_credits,
    };
  }
  function failure(error) {
    return { type: organisationConstants.ERROR_REVOKE_ORG_CREDITS, error };
  }
}

function setIds(data) {
  return (dispatch) => {

    dispatch(success(data));
  };
  function success(data) {
    return { type: "SET_ID_TO_STATE", data };
  }
}



// WEBPACK FOOTER //
// ./src/_actions/organisation.action.js